import React from 'react'

export default function NotEnoughData({ style }) {
  return (
    <div
      style={{
        position: 'absolute',
        opacity: 0.8,
        transform: 'rotate(-0.01turn)',
        width: '80%',
        height: '60%',
        // marginLeft: '10%',
        // marginTop: '15%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        fontWeight: 'bold',
        ...style
      }}
      className='border border-3 p-3 bg-warning'>
      분석할 데이터가 부족합니다.<br />
      사례관리를 시작하여 데이터를 채워주세요.
    </div>)
}

